// Order — VROC-компонент для страницы заказа

export class Order {
	constructor() {
		this.componentId = 'order';
		this.orderId = this._getOrderId();
		this._register();
	}

	_getOrderId() {
		const urlParams = new URLSearchParams(window.location.search);
		const idFromUrl = urlParams.get('id');
		if (idFromUrl) return parseInt(idFromUrl);

		const el = document.querySelector('[data-invoice-id]');
		if (el) return parseInt(el.getAttribute('data-invoice-id'));

		return null;
	}

	_register() {
		if (!this.orderId) return;

		const container = document.querySelector('.page.order');
		if (!container) return;

		// Attach к уже отрендеренному серверному HTML
		window.vroc.attachComponent({
			id: this.componentId,
			node: '.page.order',
			attach: true
		});

		console.log('[Order] Attached, id:', this.orderId);
	}

	/**
	 * Обновление заказа — запрашивает свежий HTML через AJAX и morphdom-патчит DOM
	 */
	async update() {
		if (!this.orderId) return;

		try {
			const response = await window.ajax.post('/ajax.php?mid=47', {
				action: 'loadOrder',
				id: this.orderId
			}, { dataType: 'html' });

			console.log('[Order] update response length:', response.length);
			await window.vroc.updateComponent(this.componentId, response);
			console.log('[Order] morphdom applied');

			// Переинициализируем интерактивные элементы после morphdom
			this._rebind();

		} catch (error) {
			console.error('[Order] Update error:', error);
		}
	}

	/**
	 * Переинициализация обработчиков после обновления DOM
	 */
	_rebind() {
		const container = document.querySelector('.page.order');
		if (!container) return;

		// Реинициализация datepicker-ов, form-multi и т.д.
		if (typeof window.initDatepickers === 'function') {
			window.initDatepickers(container);
		}
		if (typeof window.initFormMulti === 'function') {
			window.initFormMulti(container);
		}

		// Перебиндим попапы
		if (window.popupManager) {
			window.popupManager.bindPopupEvents(container);
		}
	}

	destroy() {
		window.vroc.detachComponent(this.componentId);
	}
}
